import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {getUserId, mobile} from '../consts/utilities';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {MatDialog} from '@angular/material/dialog';
import {AppTitleService} from '../app-title.service';
import {AppUtils} from '../app-utils';
import {ActivatedRoute} from '@angular/router';
import {CheckoutService} from '../checkout/checkout.service';
import {HttpErrorResponse, HttpStatusCode} from '@angular/common/http';
import {DefaultMCConfig} from '../consts/mc-config.const';
import {MCPersonal} from '../profile/models/mc.personal.model';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-shopping-in-store',
    templateUrl: './shopping-in-store.component.html',
    styleUrls: ['./shopping-in-store.component.scss'],
    animations: [
        trigger('fadeSlideInOut', [
            transition(':enter', [
                style({opacity: 0, transform: 'translateY(80px)'}),
                animate('300ms', style({opacity: 1, transform: 'translateY(0)'})),
            ]),
            transition(':leave', [
                animate('300ms', style({opacity: 0, transform: 'translateY(80px)'})),
            ]),
        ])
    ]
})
export class ShoppingInStoreComponent implements OnInit {

    @ViewChild('checkoutExpress')
    checkoutExpress: TemplateRef<any>;

    @ViewChild('validationExpress')
    validationExpress: TemplateRef<any>;

    @ViewChild('internalError')
    error: TemplateRef<any>;

    @ViewChild('invalidPersonalData')
    invalidDataError: TemplateRef<any>;

    public qrData: any;

    public selectedPayment: any = null;
    public paymentDesc = 'Seleccionar metodo de pago';

    private userPreviousSelection = false;
    private userHasTappedPaymentItem = false;
    // private userDismissedValidation = false;

    public nameToShow = 'Agregar';

    public phoneRequireVal: boolean;
    public emailRequireVal: boolean;

    public profileData: any = null;
    public profileModelData: any = DefaultMCConfig;

    public beforeStepInit = true;

    // Personal info before payment data is required to create Conekta user with username
    public requirePersonalValidation = false;
    public onPersonalInfoStep = false;

    public requirePaymentData = false;
    public onPaymentInfoStep = false;

    public modifyPayments = false;
    public modifyUserData = false;

    constructor(
        private checkoutService: CheckoutService,
        private matBottomSheet: MatBottomSheet,
        private dialog: MatDialog,
        private titleService: AppTitleService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.titleService.setTitle('Comprar en tienda');
    }

    ngOnInit(): void {
        this.activatedRoute.data.subscribe((data) => {
            const { response } = data;
            const {
                dataValidation, defaultPayment,
                code, user, profileModel
            } = response;

            this.getValidationResult(dataValidation);
            this.getPreselectedPayment(defaultPayment);
            this.requestSessionCode(code);
            this.analyzeUserData(user);
            this.analyzeUserConfigData(profileModel);
        });
    }

    public onDataUserContinue(event: boolean): void {
        this.onPersonalInfoStep = true;
    }

    public onPaymentUserContinue(event: boolean): void {
        this.onPaymentInfoStep = true;
    }

    public onCheckoutConfirm(event: any): void {
        const { id } = event;

        this.requirePaymentData = false;
        this.onPaymentInfoStep = false;
        this.selectedPayment = event;

        this.setDefaultPayment(id);

        if (this.modifyPayments) {
            this.modifyPayments = false;
        }
    }

    public checkPersonalData(data: MCPersonal): void {
        const { nombre, ap_paterno, ap_materno } = data;

        if (!nombre || !ap_paterno || !ap_materno) {
            // show bottom modal
            this.matBottomSheet.open(this.invalidDataError);
        }

        if (nombre && ap_paterno && ap_materno) {
            this.modifyUserData = false;
            this.nameToShow = nombre;
            this.beforeStepInit = false;
            this.requirePersonalValidation = false;
            this.onPersonalInfoStep = false;
        }
    }

    private getPreselectedPayment(response: any): void {
        if (response instanceof HttpErrorResponse) {
            this.onGetDefaultPaymentError(response);
            return;
        }

        this.onGetDefaultPaymentResponse(response);
    }

    private onGetDefaultPaymentResponse(response: any): void {
        const { data } = response;

        console.log(data);

        this.userPreviousSelection = true;
        this.selectedPayment = data;

        this.afterSelectedPayment();
    }

    private onGetDefaultPaymentError(err: HttpErrorResponse): void {
        const { status } = err;

        if (status === HttpStatusCode.NotFound) {
            this.requirePaymentData = true;
        }
    }

    private requestSessionCode(response: any): void {
        if (response instanceof HttpErrorResponse) {
            this.onRequestCodeError(response);
            return;
        }

        this.onRequestCodeSuccess(response);
    }

    private onRequestCodeSuccess(response: any): void {
        const { data } = response;
        const { codigoa } = data;
        const id = getUserId();

        this.qrData = JSON.stringify({
            userId: id,
            code: codigoa,
            method: 0
        });
    }

    private onRequestCodeError(err: Error): void {
        console.error(err);

        const isMobile = mobile();

        if (isMobile) {
            this.matBottomSheet.open(this.error);
        }

        if (!isMobile) {
            this.dialog.open(this.error);
        }
    }

    private analyzeUserData(response: any): void {
        if (response instanceof HttpErrorResponse) {
            this.onUserDataError(response);
            return;
        }

        this.onUserDataResponse(response);
    }

    private analyzeUserConfigData(response: any): void {
        if (response instanceof HttpErrorResponse) {
            console.error(response);
            return;
        }

        this.profileModelData = response;
    }

    private onUserDataResponse(response: any): void {
        const { data } = response;
        const { nombre, ap_paterno, ap_materno } = data[0];

        this.profileData = response;

        if (!nombre || !ap_paterno || !ap_materno) {
            this.beforeStepInit = true;
            this.requirePersonalValidation = true;

            return;
        }

        this.nameToShow = nombre;
    }

    private onUserDataError(err: HttpErrorResponse): void {
        console.error(err);
    }

    private getValidationResult(response: any): void {
        if (response instanceof HttpErrorResponse) {
            this.onDataValidationError(response);
            return;
        }

        this.onDataValidationResponse(response);
    }

    private onDataValidationResponse(response: any): void {
        const { data } = response;
        const { req_telefono, req_email } = data;

        this.emailRequireVal = (req_email === 0 || req_email === 2);
        this.phoneRequireVal = (req_telefono === 0 || req_telefono === 2);

        if (!this.emailRequireVal && !this.phoneRequireVal) {
            console.log('Yay! data validation passed successful.');
        }
    }

    private onDataValidationError(err: Error): void {
        console.error(err);
        // Open validation error dialog
    }

    public onSelectedPayment(event: any): void {
        this.userHasTappedPaymentItem = true;
        this.selectedPayment = event;
    }

    dismissBottom(): void {
        const isMobile = mobile();

        if (isMobile) {
            this.matBottomSheet.dismiss();
        }

        if (!isMobile) {
            this.dialog.closeAll();
        }
    }

    public openCheckoutManager(): void {
        this.modifyPayments = true;
        // const isMobile = mobile();
        //
        // // Changed for test
        // if (this.phoneRequireVal || this.emailRequireVal) {
        //     if (isMobile) {
        //         const bottom = this.matBottomSheet.open(this.validationExpress, {
        //             panelClass: 'w-100',
        //         });
        //
        //         bottom.afterOpened().subscribe(response => {
        //             console.log(response);
        //         });
        //
        //         return;
        //     }
        //
        //     if (!isMobile) {
        //         const dialog = this.dialog.open(this.validationExpress, {
        //             width: '600px',
        //             maxWidth: '600px',
        //         });
        //
        //         dialog.afterOpened().subscribe(response => {
        //             console.log(response);
        //         });
        //
        //         return;
        //     }
        // }
        //
        // if (isMobile) {
        //     const chkBottom = this.matBottomSheet.open(this.checkoutExpress);
        //     chkBottom.afterDismissed().subscribe(_ => this.afterClosedCheckout());
        // }
        //
        // if (!isMobile) {
        //     const chkDialog = this.dialog.open(this.checkoutExpress, {
        //         width: '650px',
        //         height: 'auto'
        //     });
        //
        //     chkDialog.afterClosed().subscribe(_ => this.afterClosedCheckout());
        // }
    }

    public openDataManager(): void {
        this.modifyUserData = true;
    }

    private afterClosedCheckout(): void {
        if (!this.userHasTappedPaymentItem) {
            return;
        }

        const { type } = this.selectedPayment;

        if (type === 'terminal') {
            this.paymentDesc = 'Pago en terminal';
            return;
        }

        const { id } = this.selectedPayment;

        this.setDefaultPayment(id);
    }

    private afterSelectedPayment(): void {
        if (!this.userHasTappedPaymentItem && !this.userPreviousSelection) {
            return;
        }

        const event = this.selectedPayment;
        const { type } = event;

        if (type === 'card') {
            const { brand, last4 } = event;

            this.paymentDesc = `
                ${brand[0].toUpperCase() + brand.substr(1).toLowerCase()} que termina en ${last4}`;
        }

        this.userHasTappedPaymentItem = false;
    }

    private setDefaultPayment(paymentId: string): void {
        this.checkoutService.setDefaultPayment(paymentId).subscribe(
            response => this.onDefaultPaymentResponse(response),
            err => this.onDefaultPaymentError(err)
        );
    }

    private onDefaultPaymentResponse(response: any): void {
        // const { data } = response;

        this.afterSelectedPayment();
    }

    private onDefaultPaymentError(err: Error): void {
        console.error(err);
    }

    public checkValidationResult(event: any): void {
        if (event) {
            this.phoneRequireVal = false;
            this.emailRequireVal = false;

            if (!this.selectedPayment) {
                this.requirePaymentData = true;
            }
        }
    }
}
